import * as Yup from 'yup';

export const offerChoiceValidator = Yup.object().shape({
  offerId: Yup.string()
    .required('Selection is required')
    .test('is-selected', 'Selection is required', (value) => !!value),
});
